// extracted by mini-css-extract-plugin
module.exports = {"modal":"KmodalCards_modal__fqEUG","buttons":"KmodalCards_buttons__2eI_D","button":"KmodalCards_button__3w4uF"};